import React from 'react';
import './Text.css';
import bold from './images/bold.png';
import italicIcon from './images/italic.png';
import underlineIcon from './images/underline.png';
import doc from './images/doc.png';
import left from './images/left.png';
import num from './images/num.png';
import bu from './images/bu.png';
import link from './images/link.png';
import im from './images/im.png';
import vid from './images/vid.png';

export const CustomToolbar = () => (
  <div id="toolbar">
    <select className="ql-header" defaultValue="" onChange={e => e.persist()}>
      <option value="1"></option>
      <option value="2"></option>
      <option value="3"></option>
    </select>

    <button className="ql-bold">
      <img src={bold} alt="Bold" />
    </button>
    <button className="ql-italic">
      <img src={italicIcon} alt="Italic" />
    </button>
    <button className="ql-underline">
      <img src={underlineIcon} alt="Underline" />
    </button>
    <button className="ql-strike">
      <img src={doc} alt="Strike" />
    </button>
    <button className="ql-blockquote">
      <img src={left} alt="Blockquote" />
    </button>
    <button className="ql-list" value="ordered">
      <img src={num} alt="Ordered List" />
    </button>
    <button className="ql-list" value="bullet">
      <img src={bu} alt="Bullet List" />
    </button>
    <button className="ql-link">
      <img src={link} alt="Link" />
    </button>
    <button className="ql-image">
      <img src={im} alt="Image" />
    </button>
    <button className="ql-video">
      <img src={vid} alt="Video" />
    </button>
  </div>
);

export default CustomToolbar;
